export const locale = {
    lang: 'fr',
    data: {
        TOOLBAR: {
            'ACCOUNT_SETTINGS': 'Paramètres du compte',
            'LOGOUT': 'Se déconnecter',
            'MSG': 'Envoyer un message',
            'MANAGE_PROFILE': 'Gérer le profil Qualisys'
        }
    }
}